import {Injectable} from '@angular/core';
import IFilters from "../interfaces/IFilters";

@Injectable()
class Filters {
    public list: IFilters = {
        "DATE": {
            name: 'DATE',
            options: [
                'all',
                'today',
                'yesterday',
                'last 7 days',
                'last 30 days',
                'this month',
                'custom'
            ]
        },
        'TYPE': {
            name: 'TYPE',
            options: [
                'all',
                'distance',
                'area'
            ]
        },
        'UNIT': {
            name: "UNIT",
            options: [
                'all',
                'meters',
                'miles',
            ]
        },
        'STATUS': {
            name: "STATUS",
            options: [
                'all',
                'FAVOURITES'
            ]
        }
    };
}

export default Filters;






// WEBPACK FOOTER //
// ./src/app/services/filters.service.ts